<h4 class="modal-title">Update Status</h4>
<p>Are you sure you want to update the status of {{selectedDockets?.length}} contracts to "{{status}}"?</p>
<div class="dialog-actions">
    <button type="button" mat-raised-button (click)="close()">Cancel</button>
    <button type="button" mat-raised-button [color]="'primary'"
            (click)="updateStatus()">Update Status
    </button>
</div>
